"use client";

import { useReportWebVitals } from "next/web-vitals";

import { logger } from "@/lib/logger";

/**
 * Reports Core Web Vitals (ENGINEERING.md §6). Logs at debug today; the same
 * hook point forwards to Sentry/analytics once a sink is wired. Mounted once in
 * the root layout. Renders nothing.
 */
export function WebVitals() {
  useReportWebVitals((metric) => {
    logger.debug("web-vital", {
      name: metric.name,
      value: Math.round(metric.value),
      rating: metric.rating,
      id: metric.id,
    });
  });

  return null;
}
